import { Box, Button } from '@mui/material';
import { useLang } from '../context/LangContext';

export function LangSwitcher({ light = false }: { light?: boolean }) {
  const { lang, setLang } = useLang();

  const activeStyle = {
    minWidth: 0, px: 1.4, py: 0.4, fontSize: 13, fontWeight: 800,
    borderRadius: 2, lineHeight: 1,
    bgcolor: '#fff', color: '#e65100',
    boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
    '&:hover': { bgcolor: '#fff' },
  };

  const inactiveStyle = {
    minWidth: 0, px: 1.4, py: 0.4, fontSize: 13, fontWeight: 600,
    borderRadius: 2, lineHeight: 1,
    bgcolor: '#fff', color: '#999',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    '&:hover': { bgcolor: '#f5f5f5', color: '#666' },
  };

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Button size="small" sx={lang === 'en' ? activeStyle : inactiveStyle}
        onClick={() => setLang('en')}>EN</Button>
      <Button size="small" sx={lang === 'zh' ? activeStyle : inactiveStyle}
        onClick={() => setLang('zh')}>中</Button>
    </Box>
  );
}
